import { render, staticRenderFns } from "./ZH.vue?vue&type=template&id=19045f84&scoped=true&"
import script from "./ZH.vue?vue&type=script&lang=js&"
export * from "./ZH.vue?vue&type=script&lang=js&"
import style0 from "./ZH.vue?vue&type=style&index=0&id=19045f84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19045f84",
  null
  
)

export default component.exports